/**
 * Schedules non-critical work during browser idle time to avoid blocking
 * interaction handlers and degrading INP (Interaction to Next Paint).
 */
export function scheduleIdleTask(
  task: () => void,
  timeout = 2000,
): () => void {
  if (typeof window === "undefined") {
    return () => {};
  }

  if (typeof window.requestIdleCallback === "function") {
    const id = window.requestIdleCallback(task, { timeout });
    return () => window.cancelIdleCallback(id);
  }

  const id = window.setTimeout(task, 0);
  return () => window.clearTimeout(id);
}
